import React, { useEffect, useMemo, useState } from "react";
import { getSliders } from "../Service/Api";

const FALLBACK_SLIDE =
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ABSB/public/Images/slide1.jpg";

const S3_BASE = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/";

const toAbsoluteImageUrl = (imagePath) => {
  if (!imagePath) return "";
  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath;
  }
  return `${S3_BASE}${imagePath}`;
};

const HomeSlider = () => {
  const [slides, setSlides] = useState([FALLBACK_SLIDE]);

  useEffect(() => {
    let isMounted = true;

    const loadSliders = async () => {
      try {
        const response = await getSliders();
        const payload = Array.isArray(response) ? response : response?.data;
        if (!Array.isArray(payload) || payload.length === 0) {
          if (isMounted) setSlides([FALLBACK_SLIDE]);
          return;
        }

        const mappedSlides = payload
          .filter((item) => item?.visibility === false)
          .sort((a, b) => (a?.position ?? 0) - (b?.position ?? 0))
          .map((item) => toAbsoluteImageUrl(item?.attachment))
          .filter(Boolean);

        if (isMounted) {
          setSlides(mappedSlides.length ? mappedSlides : [FALLBACK_SLIDE]);
        }
      } catch (error) {
        if (isMounted) {
          setSlides([FALLBACK_SLIDE]);
        }
      }
    };

    loadSliders();

    return () => {
      isMounted = false;
    };
  }, []);

  const renderedSlides = useMemo(
    () =>
      slides.map((src, index) => ({
        src,
        isActive: index === 0,
      })),
    [slides]
  );

  return (
    <>
      <div className="slider-sec">
        <div
          id="carouselExampleCaptions"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            {renderedSlides.map((slide) => (
              <div
                key={slide.src}
                className={`carousel-item${slide.isActive ? " active" : ""}`}
                data-bs-interval="3000"
              >
                <img
                  src={slide.src}
                  className="d-block w-100"
                  alt="Anand Bhawan School, Barabanki"
                />
              </div>
            ))}
          </div>{" "}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev"
          >
            {" "}
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>{" "}
            <span className="visually-hidden">Previous</span>{" "}
          </button>{" "}
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next"
          >
            {" "}
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>{" "}
            <span className="visually-hidden">Next</span>{" "}
          </button>
        </div>
      </div>
    </>
  );
};

export default HomeSlider;
